import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "remixicon/fonts/remixicon.css";
import "./Assets/Styles/style.scss";
import "./Assets/Styles/responsive.scss";

import ParentContext from "./Context/MainContext";
import PipelineContextProvider from "./Context/PipelineContext";
import Layouts from "./Layouts/Layouts";

//...
import * as Sentry from "@sentry/react";
import { ToastProvider } from "./Context/ToastContext";
import { LimitationProvider } from "./Context/LimitationContext";
import { useDomTextCasingNormalizer } from "./Utils/domTextCasingNormalizer";
import { sanitizeSentryEvent } from "./Utils/errorReporting";

if (process.env.REACT_APP_ENV === "production")
  Sentry.init({
    dsn: "https://64aa1687c750176e2e4059f4137e9440@o4508149482127360.ingest.us.sentry.io/4511540782039040",
    environment: process.env.REACT_APP_ENV,
    release:
      process.env.REACT_APP_SENTRY_RELEASE || process.env.REACT_APP_BUILD_ID,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // Tracing
    tracesSampleRate: 0.2,
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    beforeSend: sanitizeSentryEvent,
  });

const App = () => {
  useDomTextCasingNormalizer();

  return (
    <ParentContext>
      <ToastProvider>
        <PipelineContextProvider>
          <Router
            future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
          >
            <LimitationProvider>
              {/* Need to change layout name at the time of ui implementation */}
              <Layouts />
            </LimitationProvider>
          </Router>
        </PipelineContextProvider>
      </ToastProvider>
    </ParentContext>
  );
};

export default App;
